exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".projects {\r\n  margin-top: 170px;\r\n}\r\n\r\n.projects .project-img {\r\n  width: 70%;\r\n  height: auto;\r\n}\r\n\r\n.projects .project-desc {\r\n  color: #85baac;\r\n}\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Users/anach/Desktop/tengtu-website/src/app/components/education/projects/projects.component.css
// module id = ../../../../../src/app/components/education/projects/projects.component.css
// module chunks = main